import classNames from 'classnames';
import React from 'react';
import './Attachment.scss';
import { AttachmentProps } from './Attachment.interface';

/**
 * An attachment display component that shows an icon, name,
 * description, and an optional action slot.
 *
 * Replaces the Northstar Attachment component with a Fluent v9-compatible
 * implementation using CSS design tokens.
 */
export const Attachment: React.FC<AttachmentProps> = ({
  icon,
  header,
  description,
  action,
  onClick,
  className,
  'data-testid': dataTestId,
}) => {
  return (
    <div
      className={classNames('aix-attachment', className, {
        'aix-attachment--clickable': !!onClick,
      })}
      onClick={onClick}
      data-testid={dataTestId}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e: React.KeyboardEvent) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      {icon && <div className="aix-attachment__icon">{icon}</div>}
      <div className="aix-attachment__content">
        <span className="aix-attachment__header">{header}</span>
        {description && (
          <span className="aix-attachment__description">{description}</span>
        )}
      </div>
      {action && (
        <div
          className="aix-attachment__action"
          onClick={e => e.stopPropagation()}
        >
          {action}
        </div>
      )}
    </div>
  );
};

export default Attachment;
